import React from 'react'
import { Stack, Typography } from '@mui/material'
import { defaultPalette } from '../../../theme/idsTheme'
import { SearchRppsTitleProps } from './_props'

const SearchRppsTitle: React.FC<SearchRppsTitleProps> = ({
    display,
    title = 'Rechercher un professionnel dans l’annuaire santé',
}) => {
    if (!display) return null
    return (
        <Stack flexDirection="column" width="100%">
            <Typography fontWeight={700} fontSize="1.125rem">
                {title}{' '}
            </Typography>
            <Typography color={defaultPalette.typography.light}>
                Les champs alimentés par l’annuaire se complèteront ensuite automatiquement
            </Typography>
        </Stack>
    )
}

export default SearchRppsTitle
